import { Component, input } from '@angular/core';
import type { NonNullableFormBuilder } from '@angular/forms';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import {
  OnyxDatepickerComponent,
  OnyxSectionComponent,
  OnyxUploadComponent,
  onyxDateValidator,
  onyxMaxDateValidator,
} from '@onyx/angular';

type DriverClearCriminalRecordCertificateFormGroup = ReturnType<
  typeof DriverClearCriminalRecordCertificateFormComponent.buildForm
>;

@Component({
  selector: 'app-driver-clear-criminal-record-certificate-form',
  imports: [
    OnyxSectionComponent,
    ReactiveFormsModule,
    OnyxDatepickerComponent,
    OnyxUploadComponent,
  ],
  templateUrl: './driver-clear-criminal-record-certificate-form.component.html',
  styleUrl: './driver-clear-criminal-record-certificate-form.component.scss',
})
export class DriverClearCriminalRecordCertificateFormComponent {
  public readonly form =
    input.required<DriverClearCriminalRecordCertificateFormGroup>();

  protected readonly I18N = 'drivers.driverForm.clearCriminalRecordCertificate';

  public static buildForm(fb: NonNullableFormBuilder) {
    return fb.group({
      issuingDate: fb.control<string | null>(null, [
        Validators.required,
        onyxDateValidator,
        onyxMaxDateValidator(),
      ]),
      scans: fb.control<string[]>([]),
    });
  }
}
